import { useParams } from 'react-router-dom';
import ArticleTemplate from '@/pages/components/ArticleTemplate';
import { getArticleContent } from '@/mocks/article-content';
import NotFound from '@/pages/NotFound';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <NotFound />;
  }

  const article = getArticleContent(slug);

  if (!article) {
    return <NotFound />;
  }

  return <ArticleTemplate {...article} slug={slug} />;
}